﻿import { progressbar } from "jquery-ui-dist/jquery-ui.js";
import "jquery-ui-dist/jquery-ui.css";
import "../scss/dashboard.scss";
import "../scss/widgets.scss";

(function ($) {
    //Decalare in Global Namespace	
    window.M2 = window.M2 || {};
    window.M2.Dashboard = {};

    const setProgressBar = () => {
        $('.goal-thermometer').each(function () {
            var rawValue = $(this).data('val');
            // If it's a string remove the commas
            if (typeof rawValue === 'string') {
                if (rawValue.indexOf(',') > -1) {
                    rawValue = rawValue.replace(/,\s?/g, "");
                }
            }
            var value = parseInt(rawValue);
            var maxValue = parseInt($(this).data("total"));
            $(this).progressbar({ value: value, max: maxValue });
        });
    }

    const removeProgressBar = () => {
        $('.goal-thermometer').each(function () {
            if ($(this).progressbar('instance') !== undefined) $(this).progressbar('destroy');
        });
    }

    const handleOrientationChange = () => {
        window.addEventListener("resize", function (event) {
            removeProgressBar();
            window.setTimeout(function () {
                setProgressBar();
            }, 100);
        });
    }

    const setThingsToDoTools = () => {
        $(document).on("click", ".do-not-show-again", function (e) {
            e.preventDefault();
            M2.Util.setStorage("delayThingsToDo", true, 157784760000);
        });

        $(document).on("click", ".things-to-do-tools .btn", function (e) {
            M2.Util.setStorage("delayThingsToDo", true, 86400000);
        });
    }

    M2.Dashboard = {
        config: {
            name: "M2 Campaign Dashboard"
        },
        init: function () {
            setProgressBar();
            handleOrientationChange();
            setThingsToDoTools();
        },
        thingsToDo: function (title) {
            if (!M2.Util.getStorage("delayThingsToDo")){
                const thingsToDoHasShare = $(".things-to-do-callout").find(".icon.social").length;
                if(thingsToDoHasShare) {
                    window.setTimeout(function () {
                        const openModal = document.querySelector('.modal.fade.dynamic.show');
                        // If there aren't any open modals, we are free to show things to do.
                        if (!openModal) M2.Modal.create("things-to-do", title, "#things-overlay", "modal-md", true);
                        // Wait until the open modal is closed, then show things to do.
                        else {
                            $(openModal).on("hidden.bs.modal", function () {
                                M2.Modal.create("things-to-do", title, "#things-overlay", "modal-md", true);
                            });
                        }
                    }, 500);
                } 
            } 
        },
        refreshToDoList: function () {
            if (M2.Util.exists($("#get-notebook"))) {
                const notebookUrl = $("#get-notebook").val();
                $.ajax({
                    url: notebookUrl
                }).done(function (data) {
                    $("#todo-container .notebook-content").html(data);
                }).fail(function (xhr, ajaxOptions, thrownError) {
                    console.log(xhr.status);
                    console.log(thrownError);
                });
            }
        },
        // Profile
        updateProfileOnComplete: function (result) {
            M2.Util.successMsg();
            window.parent.$('h5.admin-name').text($('#GuardianFirstName').val() + ' ' + $('#GuardianLastName').val());
        },
        personalizedPatchOnSuccess: function () {
            $.validator.unobtrusive.parse($("#personalized-patch-overlay"));
            if ($("#personalized-patch-overlay #Success").val() == "True") {
                $("#personalized-patch-overlay .btn").hide();
                const overlayContent = $("#patch-address-container").html();
                $("#patch-address-container").fadeOut(function () {
                    $(this).html("<img src='" + M2.Util.config.pathToImages + "loading-bar.gif' class='loading-bar'>").fadeIn(function () {
                        $("#patch-address-container").delay(3000).fadeOut(function () {
                            $("#patch-address-container").html(overlayContent).fadeIn(function () {
                                // Inception
                                M2.Util.successMsg();
                                $("#personalized-patch-overlay .btn.save").show();
                            });
                        });

                    })
                });
            }
            M2.Util.setSwitches();
        }
    };
})(jQuery);

$(function () {
    M2.Dashboard.init();
});